import React from 'react'
import ExploreTopics from '../../molecules/ExploreTopics/ExploreTopics'
import PopularPosts from '../../molecules/PopularPosts/PopularPosts'

import "./AsideBar.scss"

const AsideBar = () => {
  return (
    <aside>
      <PopularPosts />
      <ExploreTopics />
    </aside>
  )
}

export default AsideBar
